exports.IF_WITH_NO_CONDITION = '<If> tag with no condition attribute';
exports.FOR_WITH_NO_ATTRIBUTES = '<For> tag with no \'each\' or \'of\' attribute';
exports.MULTIPLE_CHILDREN = 'Control statements cannot have multiple children';
exports.NO_CHILDREN = 'Control statement must have a child!';


//////////////////
// WEBPACK FOOTER
// ./~/jsx-control-statements/error-messages.js
// module id = 3201
// module chunks = 0